export function P2(props) {
	return <p className="pd-paragraph-p2">{props.children}</p>;
}

export default P2;
